import StaffLoginForm from "@/components/Auth/StaffLoginForm";

export default function ServiceLoginPage() {
    return (
        <StaffLoginForm
            title="Service Login"
            subtitle="Sign in as Service Advisor, Manager, or Technician"
            backgroundImage="/images/assets/dealership_service_futuristic_1.png"
        />
    );
}
